export default __webpack_public_path__ + "static/media/piraten_light.64ef024f.png";